/** zustand persist key  */
export const ZUSTAND_PERSIST_KEY = "ggp-zustand-persist";

export const ACCESS_TOKEN = "ggp-access-token";
export const REFRESH_TOKEN = "ggp-refresh-token";
